"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _reactAddonsShallowCompare = _interopRequireDefault(require("react-addons-shallow-compare"));
var _react = _interopRequireDefault(require("react"));
var _reactRedux = require("react-redux");
var _propTypes = _interopRequireDefault(require("prop-types"));
var _reactMomentProptypes = _interopRequireDefault(require("react-moment-proptypes"));
var _moment = _interopRequireDefault(require("moment"));
var _airbnbPropTypes = require("airbnb-prop-types");
var _reactWithStyles = require("react-with-styles");
var _actions = require("../modules/app/actions");
var _constants = require("../constants");
function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    "default": obj
  };
}
function _extends() {
  _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];
      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }
    return target;
  };
  return _extends.apply(this, arguments);
}
function _inheritsLoose(subClass, superClass) {
  subClass.prototype = Object.create(superClass.prototype);
  subClass.prototype.constructor = subClass;
  subClass.__proto__ = superClass;
}
var propTypes = process.env.NODE_ENV !== "production" ? (0, _airbnbPropTypes.forbidExtraProps)({
  styles: _propTypes["default"].object,
  //styles passed from DayPicker component
  onDatesChange: _propTypes["default"].func,
  onSelectRange: _propTypes["default"].func,
  onQuickSelect: _propTypes["default"].func,
  selectedRange: _propTypes["default"].string,
  disabledQuickSelectButtonList: _propTypes["default"].array,
  startDate: _reactMomentProptypes["default"].momentObj,
  endDate: _reactMomentProptypes["default"].momentObj
}) : {};
var RANGE_SELECTORS = [{
  key: _constants.RANGE_TYPES.SEVEN_DAYS,
  text: "Last 7 days",
  startDate: (0, _moment["default"])().subtract(7, 'days')
}, {
  key: _constants.RANGE_TYPES.THIRTY_DAYS,
  text: "Last 30 days",
  startDate: (0, _moment["default"])().subtract(30, 'days')
}, {
  key: _constants.RANGE_TYPES.THREE_MONTHS,
  text: "Last 3 months",
  startDate: (0, _moment["default"])().subtract(3, 'months')
}];
var mapStateToProps = function mapStateToProps(state) {
  return {
    selectedRange: state.rangeType
  };
};
var mapDispatchToProps = function mapDispatchToProps(dispatch) {
  return {
    onSelectRange: function onSelectRange(selectedRange) {
      dispatch((0, _actions.selectRange)(selectedRange));
    }
  };
};
var DriftQuickSelects = /*#__PURE__*/
function (_ref) {
  _inheritsLoose(DriftQuickSelects, _ref);
  var _proto = DriftQuickSelects.prototype;
  _proto[!_react["default"].PureComponent && "shouldComponentUpdate"] = function (nextProps, nextState) {
    return (0, _reactAddonsShallowCompare["default"])(this, nextProps, nextState);
  };
  function DriftQuickSelects(props) {
    return _ref.call(this, props) || this;
  }
  _proto.componentDidMount = function componentDidMount() {
    var _this$props = this.props,
      startDate = _this$props.startDate,
      endDate = _this$props.endDate,
      selectedRange = _this$props.selectedRange,
      onSelectRange = _this$props.onSelectRange;
    var maybeSelectedRange = RANGE_SELECTORS.find(function (rangeObject) {
      return rangeObject.startDate.isSame(startDate, 'day') && (0, _moment["default"])().isSame(endDate, 'day');
    });
    if (maybeSelectedRange && maybeSelectedRange.key !== selectedRange.key) {
      onSelectRange(maybeSelectedRange.key);
    }
  };
  _proto.renderButton = function renderButton(rangeObject) {
    var _this = this;
    var selectedRange = this.props.selectedRange;
    var text = rangeObject.text;
    var _this$props2 = this.props,
      styles = _this$props2.styles,
      disabledQuickSelectButtonList = _this$props2.disabledQuickSelectButtonList;
    return _react["default"].createElement("div", _extends({}, (0, _reactWithStyles.css)(styles.Quick_select_button, selectedRange === rangeObject.key && styles.Quick_select_button__selected, disabledQuickSelectButtonList.includes(rangeObject.key) && styles.Quick_select_button__disabled), {
      onClick: function onClick() {
        return _this.onButtonSelect(rangeObject);
      },
      key: text
    }), text);
  };
  _proto.onButtonSelect = function onButtonSelect(rangeObject) {
    var onDatesChange = this.props.onDatesChange;
    this.props.onSelectRange(rangeObject.key);
    this.props.onQuickSelect(rangeObject.key);
    if (rangeObject.key !== _constants.RANGE_TYPES.CUSTOM) {
      onDatesChange({
        startDate: rangeObject.startDate,
        endDate: (0, _moment["default"])()
      });
    }
  };
  _proto.render = function render() {
    var _this2 = this;
    var styles = this.props.styles;
    return _react["default"].createElement("div", (0, _reactWithStyles.css)(styles.Quick_select_button_wrapper), RANGE_SELECTORS.map(function (rangeObject) {
      return _this2.renderButton(rangeObject);
    }));
  };
  return DriftQuickSelects;
}(_react["default"].PureComponent || _react["default"].Component);
DriftQuickSelects.propTypes = process.env.NODE_ENV !== "production" ? propTypes : {};
var _default = (0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps)(DriftQuickSelects);
exports["default"] = _default;